import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import { Button, Modal, Select } from 'redpoints-front-components/index';

import { linksManagementComplaintWithdrawnReasonsFetch } from '../../../actions/linksManagementActions';
import {
  getLinksManagementComplaintWithdrawnReasonsList,
  getLinksManagementComplaintWithdrawnReasonsListIsLoading,
} from '../../../reducers/tasks/linksManagement';
import { translate } from '../../../helpers/languageHelper';

const LinksManagementComplaintWithDrawnReasonsModal = ({
  isLoading,
  linksManagementComplaintWithdrawnReasonsFetch,
  onAccept,
  onCancel,
  reasonsList,
}) => {
  const [selectedReason, setSelectedReason] = useState({});

  useEffect(() => {
    if (!isLoading && !reasonsList) {
      linksManagementComplaintWithdrawnReasonsFetch();
    }
  }, [isLoading, linksManagementComplaintWithdrawnReasonsFetch, reasonsList]);

  const handleAccept = useCallback(() => {
    if (selectedReason) {
      onAccept(selectedReason)();
    }
  }, [onAccept, selectedReason]);

  const handleChange = useCallback(
    reasonId => {
      const selectedReason = reasonsList.find(
        reason => reason.reasonId === reasonId
      );
      setSelectedReason(selectedReason);
    },
    [reasonsList]
  );

  const reasonsOptions = (reasonsList || []).map(
    ({ reasonDescription, reasonId }) => ({
      reasonId,
      reasonDescription: translate(reasonDescription),
    })
  );

  return (
    <Modal
      visible={true}
      onCancel={onCancel}
      footer={
        <>
          <div />
          <Button
            aria-label="complaint-button"
            disabled={!selectedReason.reasonId}
            loading={isLoading}
            onClick={handleAccept}
            type="primary"
          >
            {translate('actions.save')}
          </Button>
        </>
      }
    >
      <Select
        aria-label="complaint-select"
        data={reasonsOptions}
        disabled={isLoading || !reasonsList}
        label={translate(
          'tasks.links_management.modal.complaint_withdrawn_reason_label'
        )}
        mapping={{ key: 'reasonId', value: 'reasonDescription' }}
        onChange={handleChange}
        value={selectedReason.reasonId}
      />
    </Modal>
  );
};

LinksManagementComplaintWithDrawnReasonsModal.propTypes = {
  isLoading: PropTypes.bool,
  onAccept: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  reasonsList: PropTypes.arrayOf(
    PropTypes.shape({
      reasonId: PropTypes.number.isRequired,
      reasonDescription: PropTypes.string.isRequired,
    })
  ),
};

const mapStateToProps = state => ({
  isLoading: getLinksManagementComplaintWithdrawnReasonsListIsLoading(state),
  reasonsList: getLinksManagementComplaintWithdrawnReasonsList(state),
});

export default connect(mapStateToProps, {
  linksManagementComplaintWithdrawnReasonsFetch,
})(LinksManagementComplaintWithDrawnReasonsModal);
